// This file is auto-generated by next/scripts/writeFooterData.ts
// do not edit directly
export const selectedFooterId = "a584401d-f204-4b7c-af89-86b5890340b9";
export const allFooters = {
  "a584401d-f204-4b7c-af89-86b5890340b9": {
    _id: "a584401d-f204-4b7c-af89-86b5890340b9",
    primaryMenu: [
      {
        _key: "aeb54812b200",
        footerColumns: [
          {
            _key: "ad342f05ab65",
            header: null,
            spacer: null,
            content: [
              {
                _key: "fd41c24430f5",
                _type: "iconLinkGroups",
                groupType: "brexLogo",
              },
            ],
          },
          {
            _key: "49c3a9d79074",
            header: "Product",
            spacer: null,
            content: [
              {
                _key: "757e62349946",
                _type: "footerLink",
                text: "Corporate card",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product/credit-card",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "3f533a7a3953",
                _type: "footerLink",
                text: "Business banking",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product/business-account",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "e30710c7bf8a",
                _type: "footerLink",
                text: "Expense management",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product/expense-management",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "f84790de4e71bd8ab172b9e03a4f1af9",
                _type: "footerLink",
                text: "Accounting automation",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/platform/accounting-automation",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "77000ed3be19",
                _type: "footerLink",
                text: "Bill pay",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product/bill-pay",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "7d4e8409355989a1a5a2a55610890681",
                _type: "footerLink",
                text: "Travel",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product/travel",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "b82301f01024",
                _type: "footerLink",
                text: "Startups",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/solutions/startups",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "06283f59e5bb",
                _type: "footerLink",
                text: "Release notes",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product-announcements",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            ],
          },
          {
            _key: "8b4c1f33f674fa74097b666539b79662",
            header: "Platform",
            spacer: null,
            content: [
              {
                _key: "61703df87405ceb41b36240ad61692b6",
                _type: "footerLink",
                text: "Brex AI",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/platform/brex-ai",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "f90ae754a1b8",
                _type: "footerLink",
                text: "Global ready",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "",
                  toExternal: "https://www.brex.com/product/global",
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "d9fec656cd6e",
                _type: "footerLink",
                text: "Native integrations",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product/integrations",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "73aecd16538d27551bb0c3270f6303b4",
                _type: "footerLink",
                text: "Live Budgets",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/budgets",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "4b1e457b5e20cf58eb594dfabb1b3874",
                _type: "footerLink",
                text: "Reporting",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/platform/reporting",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "75b435e9d402",
                _type: "footerLink",
                text: "Mobile app",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product/mobile",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "f9ad5575e67c",
                _type: "footerLink",
                text: "API",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/product/api",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
            ],
          },
          {
            _key: "357a074e1c53",
            header: "Company",
            spacer: null,
            content: [
              {
                _key: "9ca130963f23",
                _type: "footerLink",
                text: "About Brex",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/about",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "dbb1fc53ddcc",
                _type: "footerLink",
                text: "Careers",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/careers",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "4dd9be009189",
                _type: "footerLink",
                text: "Contact",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/contact-us",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "6a7cd847585a",
                _type: "footerLink",
                text: "Partner portal",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/partners",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "ed0a6d6030cc",
                _type: "footerLink",
                text: "Press",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/journal/press",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "7149a7c7440d8914f5e01d23b5e4203a",
                _type: "footerLink",
                text: "Security",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "",
                  toExternal: "https://www.brex.com/trust",
                  noFollow: null,
                  hash: null,
                },
              },
            ],
          },
          {
            _key: "9fd84d77cd35",
            header: "Resources",
            spacer: null,
            content: [
              {
                _key: "85f1f7eaed29",
                _type: "footerLink",
                text: "Customer Hub",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/customer-hub",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "1f9ce69fc20c",
                _type: "footerLink",
                text: "Help center",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/support",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "848f91c71d25b2f60a6f4027c77c25f8",
                _type: "footerLink",
                text: "Resource center & blog",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/resources",
                  toExternal: null,
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "1f85e0a4cfaf",
                _type: "footerLink",
                text: "Spend trends",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/spend-trends",
                  toExternal: null,
                  noFollow: false,
                  hash: null,
                },
              },
              {
                _key: "601ba47c47ed",
                _type: "footerLink",
                text: "Accounting services",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: null,
                  toExternal: "https://www.brex.com/directory",
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "3504c86d2709",
                _type: "footerLink",
                text: "Status",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: null,
                  toExternal: "https://status.brex.com",
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "56dd5645670c",
                _type: "footerLink",
                text: "Implementation services",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: "/professional-services",
                  toExternal: null,
                  noFollow: false,
                  hash: null,
                },
              },
              {
                _key: "fb1aa1d6ec11",
                _type: "footerLink",
                text: "Legal",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: null,
                  toExternal: "https://www.brex.com/legal/platform-agreement",
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "1cc803475da2",
                _type: "footerLink",
                text: "Privacy",
                cookiePopup: false,
                link: {
                  _key: null,
                  to: null,
                  toExternal: "https://privacy.brex.com/",
                  noFollow: null,
                  hash: null,
                },
              },
              {
                _key: "f2b18ec61240",
                _type: "footerLink",
                text: "Cookie preferences",
                cookiePopup: true,
                link: null,
              },
            ],
          },
        ],
      },
    ],
    secondaryMenu: [
      {
        _key: "097ae3016b99",
        footerColumns: [
          {
            _key: "acb9e486b450",
            header: null,
            spacer: null,
            content: [
              {
                _key: "ae6c03119b5f",
                _type: "iconLinkGroups",
                groupType: "social",
              },
            ],
          },
          {
            _key: "aa45d02fc736",
            header: null,
            spacer: null,
            content: [
              {
                _key: "5b9bd81902d7",
                _type: "iconLinkGroups",
                groupType: "appStore",
              },
            ],
          },
          { _key: "0c5ef604d49f", header: null, spacer: true, content: null },
          { _key: "921006029b49", header: null, spacer: true, content: null },
        ],
      },
    ],
  },
};
